import {
  BreakPointCondition,
  Icon,
  Text,
  useBreakpointIf,
  HStack,
  Stack,
} from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box, Pressable } from 'native-base';
import React, { useCallback } from 'react';

namespace HeaderTypes {
  interface StatusType {
    status: 'lock' | 'pending';
  }

  interface OnPressType {
    onPress: () => void;
  }

  export type UnlockButtonProps = OnPressType;
  export type GoBackButtonProps = OnPressType;
  export type Props = StatusType;
  export type DetailStatusProps = StatusType;
}

const GoBackButton: React.FC<HeaderTypes.GoBackButtonProps> = ({ onPress }) => (
  <Pressable onPress={onPress}>
    <HStack space={Spacing['inline.nano']} alignItems={'center'}>
      <Icon name="ArrowLeft" size="xs" testId="back-icon" />
      <Text variant="semibold" fontSize={Typography['fontsize.lg']}>
        Desbloquear contato
      </Text>
    </HStack>
  </Pressable>
);

export const Header: React.FC<HeaderTypes.Props> = () => {
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  if (isMobile) {
    return (
      <Stack direction={'column'} testID="heading" display="flex" space={Spacing['inline.xxxs']}>
        <GoBackButton onPress={goBack} />
      </Stack>
    );
  }

  return (
    <Box testID="heading" display="flex" alignItems="center">
      <HStack flex={1} alignItems="center" justifyContent={'space-between'} w={'full'}>
        <HStack space={Spacing['inline.nano']} alignItems={'center'} justifyContent={'center'}>
          <GoBackButton onPress={goBack} />
        </HStack>
        <HStack alignItems={'center'} justifyContent={'center'} space={Spacing['inline.xxs']}>
          <Pressable onPress={goBack}>
            <Icon name="CloseModal" size="xs" testId="close-icon" variant="rounded-border" />
          </Pressable>
        </HStack>
      </HStack>
    </Box>
  );
};
